import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Modaal, Buttton } from "../../components";

import { Commons } from "../../utilities";
import { useNavigate } from "react-router-dom";

const ForgotCommonPage = ({ userType, closeNavigate, forgotSubmit }) => {

    const navigate = useNavigate();
    const { t } = useTranslation();
    const txtContent = {
        title: (
            <div className="mTitleBlk">
                <h2 className="mTitle">{t("forgotPasswordPage.title")}</h2>
                <p className="mSubTitle">{t("forgotPasswordPage.subTitle")}</p>
            </div>
        ),
        email: t("email"),
        email_placeholder: t("email_placeHolder"),

        childrens: {
            children1: t("reset_password"),
        },
    };
    const [showModal] = useState(true);
    const handleCloseModal = () => {
        navigate(closeNavigate);
    };
    const [credentials, setCredentials] = useState({
        email: "",
        userType: userType,
    });
    const [errors, setErrors] = useState({});
    const validationRules = {
        email: {
            required: true,
            email: true,
        },
    };
    const handleChange = (e) => {
        const { name, value } = e.target;
        setCredentials((prevCredentials) => ({
            ...prevCredentials,
            [name]: value,
        }));
    };
    const handleSubmit = (credentials) => {
        const validationErrors = Commons.validate(credentials, validationRules);
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
        } else {
            forgotSubmit(credentials)
        }
    };
    const inputFields = [
        {
            label: txtContent.email,
            type: "email",
            placeholder: txtContent.email_placeholder,
            name: "email",
        },
    ];

    const footer = (
        <>
            <div className="modal-footer-blk">
                <div>

                </div>
                <Buttton.Buttton
                    children={txtContent.childrens.children1}
                    onClick={() => handleSubmit(credentials)}
                    className="btn-solid-Aqua_Teal"
                />
            </div>
        </>
    );



    return (
        <div>
            <Modaal.AuthModal
                show={showModal}
                onHide={handleCloseModal}
                title={txtContent.title}
                inputFields={inputFields}
                credentials={credentials}
                handleChange={handleChange}
                errors={errors}
                footer={footer}
                centered="true"
                className="auth-modal forgot-modal"
            />
        </div>
    )
}

export default ForgotCommonPage;
